import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { ActiveForm } from '@components/Checkout/steps/CustomerInfoStep/ActiveForm';
import { ViewOnly } from '@components/Checkout/steps/CustomerInfoStep/ViewOnly';
import type { CustomerInfoStepProps } from '@components/Checkout/steps/CustomerInfoStep/CustomerInfoStep.types';

export const CustomerInfoStep = ({
  isActive,
  isCompleted,
  metadata,
  isMetadataLoading,
  serviceAddress,
  savedValues,
  isSaving,
  onSave,
  onEditServiceAddress,
}: CustomerInfoStepProps) => {
  if (isCompleted && !isActive) {
    return <ViewOnly metadata={metadata} serviceAddress={serviceAddress} savedValues={savedValues} />;
  }

  if (!isActive) return null;

  if (isMetadataLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ActiveForm
      metadata={metadata}
      serviceAddress={serviceAddress}
      savedValues={savedValues}
      isSaving={isSaving}
      onSave={onSave}
      onEditServiceAddress={onEditServiceAddress}
    />
  );
};
